import { Types } from '../constants/actionTypes';
import configureStore from '../store/configureStore';
import { toast } from 'react-toastify';

const store = configureStore();

const SESSION_EXPIRED_MSG = "Your session is expired please login again.";

function handleUnauthorised() {
  store.dispatch({ type: Types.LOGIN, payload: { user: '' } });
  toast.error(SESSION_EXPIRED_MSG);
}

const GetApiCall = async (url, header) => {
  try {
    const response = await fetch(url, { method: 'GET', headers: header });
    if (response.status === 401) { handleUnauthorised(); return null; }
    return response.json();
  } catch (error) {
    console.error('GET request failed:', error?.message);
    return null;
  }
};

const PostApiCall = async (url, payLoad, header) => {
  const hasBody = payLoad && Object.keys(payLoad).length > 0;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: header,
      ...(hasBody ? { body: payLoad } : {}),
    });
    if (response.status === 401) { handleUnauthorised(); return null; }
    return response.json();
  } catch (error) {
    console.error('POST request failed:', error?.message);
    return null;
  }
};

const GetBlobApiCall = async (
  url,
  header,
) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: header,
    });

    if (response.status === 401) {
      handleUnauthorised();
      return { blob: null, filename: null };
    }

    if (!response.ok) {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        let errorData;
        try {
          errorData = await response.json();
        } catch {
          throw new Error(`Export failed with status ${response.status}`);
        }
        throw new Error(errorData.message || `Export failed with status ${response.status}`);
      } else {
        const errorText = await response.text();
        throw new Error(errorText || `Export failed with status ${response.status}`);
      }
    }

    // Get filename from Content-Disposition header before converting to blob
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = null;
    if (contentDisposition) {
      // Try multiple patterns to match different header formats
      // Format 1: filename="USER_LIST_2026-01-17.csv"
      // Format 2: filename=USER_LIST_2026-01-17.csv
      // Format 3: filename*=UTF-8''USER_LIST_2026-01-17.csv
      const filenameMatch = contentDisposition.match(/filename[*]?=["']?([^"';]+)["']?/i);
      if (filenameMatch) {
        filename = filenameMatch[1];
        // Decode URI-encoded filenames (for filename*=UTF-8''... format)
        if (filename.includes('%')) {
          try {
            filename = decodeURIComponent(filename);
          } catch (e) {
            // If decoding fails, use as-is
          }
        }
      }
    }

    // Debug logging for filename extraction
    if (process.env.NODE_ENV === 'development') {
      console.log('📄 Content-Disposition header:', contentDisposition);
      console.log('📄 Extracted filename:', filename);
    }

    // If no filename in header, use default matching backend format
    if (!filename) {
      filename = `USER_LIST_${new Date().toISOString().split('T')[0]}.csv`;
    }

    const blob = await response.blob();
    
    // Check if blob is suspiciously small (might be empty or error)
    if (blob.size < 50) {
      const text = await blob.text();
      // If it's just headers or empty, log it
      if (text.split('\n').filter(line => line.trim()).length <= 1) {
        console.warn('⚠️ Export response appears to be empty or only contains headers');
      }
    }
    
    return { blob, filename };
  } catch (error) {
    console.error('Error on the GET blob request', error?.message);
    throw error;
  }
};

const apiCalls = {
  GetApiCall,
  PostApiCall,
  GetBlobApiCall,
};

export default apiCalls;